export const environment = {
  production: false,
  apiUrl: 'https://api.demo.dx-compliance.com/v1',
  customer: 'dx',
  branch: 'demo',
  featureFlags: [
    'moduleHomeMyCases',
    'moduleCasesOpen',
    'moduleCasesClosed',
    'moduleCasesCustomer',
    'moduleCasesElliptic',
    'moduleCasesTransaction',
    'moduleCasesTravelRule',
    'moduleRuleEngine',
    'moduleDxTective',
    'moduleCustomers',
    'moduleTransactions',
    'moduleSar',
    'moduleCharts',
    'moduleLeadership',
    'moduleUsers',
    'moduleAuditTrail',
    'moduleUploadData',
    'moduleMyAccount',
    'moduleAppSettings',
    'routeAppSettingsRetailRiskFactors',
    'routeAppSettingsCorporateRiskFactors',
    'routeAppSettingsAdverseMedia',
    'routeAppSettingsHifcaHidta',
    'routeUserProfile',
    'routeAppSettingsScreeningLists',
    'componentMyCasesStats',
  ]
};
